import { Component, OnInit, HostListener } from "@angular/core";
import { NavigationEnd, Router, Event, ActivatedRoute } from "@angular/router";
import { CookieService } from "ngx-cookie-service";
import { SessionService } from "./services/session/session.service";

declare var ga: Function;
declare var require: Function;

@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private session: SessionService,
    private cookieService: CookieService
  ) {
    /**
     * event listener for route changing
     * tracking for google analytics
     */
    this.router.events.subscribe((event: Event) => {
      try {
        if (typeof ga === "function") {
          if (event instanceof NavigationEnd) {
            ga("set", "page", event.urlAfterRedirects);
            ga("send", "pageview");
          }
        }
      } catch (e) {
        console.log(e);
      }
    });
  }

  onConsentStatusChange(consentStatus: boolean) {
    if (consentStatus) {
      // Set cookies
      require("../static/googleAnalyticsScript.js");
    } else {
      this.gaOptout();
      this.cookieService.delete("_ga", "/");
      this.cookieService.delete("_gat_gtag_UA_115747418_1", "/");
      this.cookieService.delete("_gid", "/");
    }
  }

  gaOptout() {
    let gaProperty = "UA-115747418-2";
    let disableStr = "ga-disable-" + gaProperty;
    document.cookie =
      disableStr + "=true; expires=Thu, 31 Dec 2099 23:59:59 UTC; path=/";
    window[disableStr] = true;
    alert("Das Tracking ist jetzt deaktiviert");
  }

  checkForConsented() {
    //console.log("Checking...");
    return localStorage.getItem("cookie_consent_status");
  }

  @HostListener("window:storage", ["$event"])
  onStorageEvent(event) {
    if (event.key == "getSessionStorage") {
      localStorage.setItem("sessionStorage", JSON.stringify(sessionStorage));
      localStorage.removeItem("sessionStorage");
    } else if (event.key == "logout") {
      this.session.destroy();
      this.router.navigate(["/login"]);
    }
  }

  ngOnInit(): void {
    localStorage.removeItem("getSessionStorage");
    sessionStorage.removeItem("getSessionStorage");
  }
}



// WEBPACK FOOTER //
// /agir/src/app/app.component.ts